import { render } from "./Video.vue?vue&type=template&id=2291458d&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import "./Video.vue?vue&type=style&index=0&id=2291458d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2291458d"

export default script